export enum DicTypeKeyEnum {
  Menu = "menus",
  Shift = "shifts",
  Localization = "localizations",
  AppUser = "app-users",
  BpUser = "bp-users",
  SettingGroup = "setting-groups",
  Setting = "setting-items",
  MeasurementUnit = "measurement-units",
  BusinessPartner = "business-partners",
  MaintenancePartner = "maintenance-partners",
  EquipmentBrand = "equipment-brands",
  EquipmentModel = "equipment-models",
  CostCentre = "cost-centres",
  Location = "locations",
  WorkCentre = "work-centres",
  ServiceZone = "service-zones",
  Division = "divisions",
  Department = "departments",
  Group = "groups",
  EquipmentType = "equipment-types",
  Property = "properties",
  Fleet = "fleets",
  EquipmentMaintenanceType = "equipment-maintenance-types",
  RequestPriority = "request-priorities",
  EquipmentBookingAuthorization = "equipment-booking-authorizations",
  Device = "devices",
  Guide = "guide",
}
